<div class="bg-dark mobile-widget-container">
  <div class="bg-dark action-bar-mobile-widget d-block d-lg-none">
    <button
      (click)="closeModal()"
      class="close icon-moreoptionsclose float-left"
      type="button"
    >
      <img
        alt="close"
        src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
      />
    </button>
  </div>
  <div class="mobile-widget-scrollable-container" id="mobileContainer">
    <div class="widget-container-lg nav-content-outlet bg-dark main-container">
      <app-links-content-mobile-container
        (navItemClicked)="toggleContent($event)"
        *ngIf="!(selectedNavItem === 'flightstatus' && isMobile)"
        [isMobileDevice]="isMobile"
        [selectedItem]="selectedNavItem"
        class="d-block d-lg-none"
      ></app-links-content-mobile-container>
      <ngc-book
        #navigationBookComponent
        (onFromAirportSearched)="onFromAirportSearched($event)"
        (onToAirportSearched)="onToAirportSearched($event)"
        *ngIf="selectedNavItem === 'book'"
        [airPortForOdPair]="airPortForOdPair"
        [businessAccountOptionsList]="businessAccountOptionsList"
        [corpPartner]="corpPartner"
        [custId]="custId"
        [fromAirport]="fromAirport"
        [inMobile]="true"
        [isEDPFlag]="isEDPFlag"
        [isWidgetAlwaysExpanded]="true"
        [mkcpgn]="mkcpgn"
        [mobileNav]="mobileNav"
        [prefCity]="prefCity"
        [queryParam]="queryParam"
        [recentSelected]="recentSelected"
        [savedSelected]="savedSelected"
        [toAirport]="toAirport"
        [canBookNonRefundable]="canBookNonRefundable"
        [isloggedIn]="isloggedIn"
      ></ngc-book>
      <ngc-checkin *ngIf="selectedNavItem === 'check_in'"></ngc-checkin>
      <ngc-mytrips *ngIf="selectedNavItem === 'my_trips'"></ngc-mytrips>
      <h3
        *ngIf="selectedNavItem === 'flightstatus' && isMobile"
        class="flstatus-title"
      >
        Flight Status
      </h3>
      <ngc-flight-status
        *ngIf="selectedNavItem === 'flightstatus'"
      ></ngc-flight-status>
      <ngc-app-sec-links-content
        *ngIf="
          selectedNavItem === 'secondarynav' ||
          selectedNavItem === 'sky-miles' ||
          selectedNavItem === 'more'
        "
        [navbarSecondaryLink]="selectedNavItem"
      ></ngc-app-sec-links-content>
    </div>
  </div>
</div>
